import { Badge, Box, Flex, Grid, GridItem, Image, Spacer, Text } from "@chakra-ui/react";
import { LazyLoadComponent } from "react-lazy-load-image-component";

import { brandColor } from "@/utilities/color-presets/colorConfig";

function NewGuiaCard({
    id,
    title,
    subTitle,
    badgeText,
    minPrice,
    link,
    imageUrl,
    propertyType = null,
    referred,
    isOnlineSale,
    isKoppiActive,
}) {
    const redirectNewPage = () => {
        if (referred) {
            window.open(link, "_blank");
        }
    };

    function capitalize(str) {
        if (!str || typeof str !== "string") return str;

        return str
            .split(" ")
            .map((word) => {
                if (/\d/.test(word)) {
                    return word;
                }
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(" ");
    }

    return (
        <LazyLoadComponent id={id}>
            <Box
                display="flex"
                minW="320px"
                onClick={() => redirectNewPage()}
                h="465px"
                as="div"
                mt={0}
                borderRadius="lg"
                position="relative"
                overflow="hidden"
                cursor="pointer"
                transition="all 0.2s ease-in-out"
                _hover={{
                    transform: "translateY(-4px)",
                    boxShadow: "lg",
                }}
                _active={{
                    transform: "translateY(-2px)",
                }}
                _focus={{
                    outline: "2px solid",
                    outlineColor: "blue.500",
                    outlineOffset: "2px",
                }}
            >
                <Box position="absolute" w="100%" h="100%" zIndex={0}>
                    <Image
                        src={imageUrl}
                        alt={`${capitalize(title)} - ${subTitle}`}
                        fill
                        sizes="(max-width: 768px) 100vw, 320px"
                        style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                        }}
                        // quality={85}
                        // priority={false}
                    />
                </Box>
                <Box
                    position="absolute"
                    w="100%"
                    h="100%"
                    bgGradient="to-t"
                    gradientFrom="rgba(0, 0, 0, 1)"
                    gradientVia="transparent"
                    gradientTo="transparent"
                    zIndex={1}
                />

                {/* Contenido */}
                <Flex direction="column" w="100%" h="100%" position="relative" zIndex={2}>
                    <Flex direction="column" width="full" align="end">
                        <Grid
                            templateColumns={{ base: "repeat(3, 1fr)", md: "repeat(3, 1fr)" }}
                            span={2}
                            w="full"
                            pr={3}
                        >
                            <GridItem colSpan={1}>
                                {isOnlineSale && (
                                    <Badge
                                        padding="2"
                                        borderRadius="md"
                                        marginTop="10px"
                                        color="#fff"
                                        bg="#5F9F1E"
                                        fontWeight="700"
                                        boxShadow="md"
                                        position="relative"
                                        fontSize="xs"
                                        left="20px"
                                        top="5px"
                                        textTransform="none"
                                        maxH="35px"
                                    >
                                        Aparta online
                                    </Badge>
                                )}
                            </GridItem>
                            <GridItem colSpan={2}>
                                {isKoppiActive && (
                                    <Badge
                                        padding="2"
                                        borderRadius="md"
                                        marginTop="10px"
                                        borderWidth={1}
                                        borderColor="#002B49"
                                        color="#002B49"
                                        bg="#FFFFFF"
                                        fontWeight="700"
                                        boxShadow="md"
                                        position="relative"
                                        fontSize="xs"
                                        left="20px"
                                        top="5px"
                                        textTransform="none"
                                        gap={2}
                                        maxH="33px"
                                        ml={5}
                                    >
                                        <Image
                                            src="https://media.grupoguia.mx/assets/icons/virtual_route.svg"
                                            alt="virtual_route"
                                        />
                                        Recorrido virtual
                                    </Badge>
                                )}
                            </GridItem>
                        </Grid>
                    </Flex>
                    <Spacer />
                    <Flex direction="column" w="full" alignItems="start">
                        <Box
                            borderBottomRadius="10px"
                            padding={6}
                            bg="transparent"
                            shadow="md"
                            width="full"
                        >
                            <Text
                                as="h3"
                                display="-webkit-box"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                lineClamp={2}
                                _hover={{
                                    textDecoration: "none",
                                    ...brandColor,
                                }}
                                fontWeight="600"
                                fontSize="lg"
                                letterSpacing="wide"
                                color="#FFFFFF"
                                textTransform="none"
                                textAlign="left"
                            >
                                {capitalize(title)}
                            </Text>
                            <Text
                                as="span"
                                _hover={{
                                    textDecoration: "none",
                                    ...brandColor,
                                }}
                                fontWeight="400"
                                fontSize="lg"
                                lineClamp={1}
                                letterSpacing="wide"
                                color="#FFFFFF"
                                textTransform="none"
                                display="block"
                                textAlign="left"
                                mt={2}
                            >
                                {subTitle}
                            </Text>
                        </Box>
                    </Flex>
                </Flex>
            </Box>
        </LazyLoadComponent>
    );
}

export default NewGuiaCard;
